import handIcon from "./level2/hand.png";

let dragImageEl = null;

const dragVisual = {
  el: null,
  handEl: null,
  offsetX: 0,
  offsetY: 0,
};

export function setEmptyDragImage(e) {
  if (!dragImageEl) {
    dragImageEl = document.createElement("div");
    dragImageEl.style.width = "1px";
    dragImageEl.style.height = "1px";
    dragImageEl.style.opacity = "0";
    dragImageEl.style.position = "fixed";
    dragImageEl.style.top = "-9999px";
    dragImageEl.style.pointerEvents = "none";
  }
  if (!dragImageEl.parentNode) {
    document.body.appendChild(dragImageEl);
  }
  e.dataTransfer.setDragImage(dragImageEl, 0, 0);
}

export function clearEmptyDragImage() {
  dragImageEl?.remove();
}

export function mountDragVisual(sourceEl, clientX, clientY, { floatClass, draggingClass }) {
  unmountDragVisual();

  const rect = sourceEl.getBoundingClientRect();
  dragVisual.offsetX = clientX - rect.left;
  dragVisual.offsetY = clientY - rect.top;

  const float = sourceEl.cloneNode(true);
  float.classList.remove(draggingClass);
  float.classList.add(floatClass);
  float.removeAttribute("draggable");
  float.style.width = `${rect.width}px`;
  float.style.minHeight = `${rect.height}px`;
  float.style.height = "auto";

  const hand = document.createElement("img");
  hand.src = handIcon;
  hand.className = "stage1-drag-hand-cursor";
  hand.alt = "";
  hand.draggable = false;

  document.body.appendChild(float);
  document.body.appendChild(hand);
  dragVisual.el = float;
  dragVisual.handEl = hand;
  moveDragVisual(clientX, clientY);
}

export function moveDragVisual(clientX, clientY) {
  if (clientX === 0 && clientY === 0) return;

  if (dragVisual.el) {
    dragVisual.el.style.left = `${clientX - dragVisual.offsetX}px`;
    dragVisual.el.style.top = `${clientY - dragVisual.offsetY}px`;
  }

  if (dragVisual.handEl) {
    dragVisual.handEl.style.left = `${clientX}px`;
    dragVisual.handEl.style.top = `${clientY}px`;
  }
}

export function unmountDragVisual() {
  dragVisual.el?.remove();
  dragVisual.handEl?.remove();
  dragVisual.el = null;
  dragVisual.handEl = null;
}
